/* 'use client';

import React, { useState, useEffect, Suspense } from 'react';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../../firebaseConfig';

const AdminContactMessages = () => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'contactMessages'));
        const data = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setMessages(data);
      } catch (error) {
        console.error('Error fetching contact messages:', error);
      }
    };

    fetchMessages();
  }, []);

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, 'contactMessages', id));
      setMessages(prev => prev.filter(msg => msg.id !== id));
      alert('Message deleted.');
    } catch (error) {
      console.error('Failed to delete message:', error);
      alert('Error deleting message.');
    }
  };

  return (
    <div className="container py-4">
      <h2 className="text-center text-uppercase mb-4">Contact Messages</h2>

      {messages.length === 0 ? (
        <p className="text-center">No messages found.</p>
      ) : (
        <div className="row g-4">
          {messages.map(msg => (
            <div key={msg.id} className="col-md-6">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <h5 className="card-title">{msg.subject || 'No Subject'}</h5>
                  <p><strong>Name:</strong> {msg.name}</p>
                  <p><strong>Email:</strong> {msg.email}</p>
                  <p><strong>Message:</strong><br />{msg.message}</p>
                  <p className="text-muted small">
                    {msg.createdAt?.toDate?.().toLocaleString?.() || 'No Timestamp'}
                  </p>
                </div>
                <div className="card-footer text-center">
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(msg.id)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const AdminContactMessagesPage = () => (
  <Suspense fallback={<div className="text-center py-5">Loading messages...</div>}>
    <AdminContactMessages />
  </Suspense>
);

export default AdminContactMessagesPage;
 */
'use client';

import React, { useState, useEffect, Suspense } from 'react';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../../firebaseConfig';

const AdminContactMessages = () => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'contactMessages'));
        const data = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setMessages(data);
      } catch (error) {
        console.error('Error fetching contact messages:', error);
      }
    };

    fetchMessages();
  }, []);

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, 'contactMessages', id));
      setMessages(prev => prev.filter(msg => msg.id !== id));
      alert('Message deleted.');
    } catch (error) {
      console.error('Failed to delete message:', error);
      alert('Error deleting message.');
    }
  };

  return (
    <div className="container py-4">
      <h2 className="text-center text-uppercase mb-4">Contact Messages</h2>

      {messages.length === 0 ? (
        <p className="text-center">No messages found.</p>
      ) : (
        <div className="row g-4">
          {messages.map(msg => (
            <div key={msg.id} className="col-md-6">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <p><strong>Name:</strong> {msg.name}</p>
                  <p><strong>Email:</strong> {msg.email}</p>
                  <p><strong>Phone:</strong> {msg.phone || 'N/A'}</p>
                </div>
                <div className="card-footer text-center">
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(msg.id)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const AdminContactMessagesPage = () => (
  <Suspense fallback={<div className="text-center py-5">Loading messages...</div>}>
    <AdminContactMessages />
  </Suspense>
);

export default AdminContactMessagesPage;
